<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_TASK_LIST')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh mục công việc</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          @click="$router.push('/cat-calendar-afs-add')"
          v-if="dataPermission.includes('CNPS_CALENDAR_WK_TASK_INSERT')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button
          @click="$router.push('/cat-calendar-afs-import')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-upload"></i> Nhập file
        </button>
        <button
          @click="exportExcel"
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission.includes('CNPS_CALENDAR_WK_TASK_XLS')"
        >
          <i class="bx bx-download"></i> Xuất file
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="search.service" :options="optionService" placeholder="Dịch vụ">
            </Select2>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.taskName"
              class="form-control f12 hc-37"
              placeholder="Tên danh mục"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="optionStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng danh mục công việc</b>: {{ pagination.total }}</span>
            <b-table
              :busy.sync="loading"
              sticky-header
              responsive
              hover
              :items="dataCat"
              :fields="filterTable"
              selectable
              select-mode="single"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(createdDate)="data">
                {{ data.item.createdDate | formatDate }}
              </template>
              <template #cell(status)="data">
                <b-badge
                  class="font-size-12"
                  pill
                  :variant="data.item.status == 'APPLYING' ? 'primary' : 'danger'"
                  size="sm"
                >
                  {{ data.item.status | mapStatus(optionStatus) }}
                </b-badge>
              </template>
              <template #cell(type)="data">
                {{ getNameType(data.item.type) }}
              </template>

              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="onRowSelected(data.item)">Chi tiết</b-dropdown-item>
                  <b-dropdown-item
                    @click="$router.push({ path: `/cat-calendar-afs/${data.item.id}` })"
                    v-if="
                      data.item.status == 'APPLYING' &&
                      dataPermission.includes('CNPS_CALENDAR_WK_TASK_UPDATE')
                    "
                    >Sửa</b-dropdown-item
                  >
                  <b-dropdown-item
                    @click="LocknUnlockCat(data.item)"
                    v-if="data.item.status == 'APPLYING'"
                    >Khoá</b-dropdown-item
                  >
                  <b-dropdown-item @click="LocknUnlockCat(data.item)" v-else
                    >Mở khoá</b-dropdown-item
                  >
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.size"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <!-- Modal xác nhận mở khoá/ khoá-->
    <b-modal id="modal-scoped" v-model="lockModal">
      <template #modal-header="{ close }">
        <h5 v-if="stateGr.status == 'APPLYING'">Khoá danh mục công việc</h5>
        <h5 v-else>Mở khoá danh mục công việc</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="py-3 f18" v-if="stateGr.status == 'APPLYING'">
          Bạn muốn khoá danh mục công việc này ?
        </h2>
        <h2 class="py-3 f18" v-else>Bạn muốn mở khoá danh mục công việc này ?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="cancel(), confirmLocknActive()">
          Xác nhận
        </b-button>
      </template>
    </b-modal>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'createdDate', label: 'Thời gian tạo' },
    { key: 'groupName', label: 'Tên nhóm' },
    { key: 'taskName', label: 'Tên công việc' },
    { key: 'taskCode', label: 'Mã công việc' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'type', label: 'Loại công việc' },
    { key: 'reviewTime', label: 'Thời gian đánh giá điểm' },
    { key: 'condition', label: 'Điều kiện đánh giá' },
    { key: 'point', label: 'Điểm đánh giá' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    components: {
      DateRangePicker,
    },
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        optionPurpose: Config.typePurposeOption || [],
        search: {
          page: 1,
          size: 20,
        },
        pagination: {
          total: 0,
        },
        dataCat: [],
        fieldsTable,
        filterTable: fieldsTable,
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        loading: false,
        showLoading: false,
        optionService: [],
        optionStatus: Config.statusCalendar,
        lockModal: false,
        stateGr: {},
      }
    },
    created() {
      this.fetchData()
      this.getListService()
    },
    computed: {
      getNameType() {
        return type => {
          const map = this.optionPurpose?.reduce((acc, cur) => {
            acc[cur.id] = cur.text
            return acc
          }, {})
          return map[type] || type
        }
      },
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    methods: {
      async exportExcel() {
        try {
          await CalendarAfsService.exportCatCalendar(this.search)
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        try {
          if (this.search.service === '0') delete this.search.service
          if (this.search.status === '0') delete this.search.status
          this.loading = true
          const data = await CalendarAfsService.catCalendar(this.search)
          if (data.success) {
            this.pagination.total = data.totalPage.total ? data.totalPage.total : 0
            this.dataCat = data.data
          }
          if (data.code === 1004) {
            this.dataCat = []
            this.pagination.total = 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      transfromDate() {
        this.search.fromDate = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.toDate = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          size: 50,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      // list Dịch vụ
      async getListService() {
        try {
          const data = await SalesManagerService.getGroupService({})
          if (data.success) {
            this.optionService = data.data.groupService
              .map(e => e.detail)
              .flat()
              .map(el => {
                return {
                  id: el.code,
                  text: el.name,
                }
              })
            this.optionService.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      onRowSelected(item) {
        window.open(`/cat-calendar-afs/detail/${item.id}`, '_blank')
      },
      LocknUnlockCat(item) {
        this.stateGr = item
        this.lockModal = true
      },
      async confirmLocknActive() {
        try {
          this.showLoading = true
          if (this.stateGr.status === 'APPLYING') {
            const data = await CalendarAfsService.lockCatCalendar({
              id: this.stateGr.id,
            })
            if (data.success) {
              this.notiModal = true
              this.iconNoti = require('@/assets/img/noti-success2.svg')
              this.msgNoti = 'Khoá thành công'
            }
          } else {
            const data = await CalendarAfsService.unlockCatCalendar({ id: this.stateGr.id })
            if (data.success) {
              this.notiModal = true
              this.iconNoti = require('@/assets/img/noti-success2.svg')
              this.msgNoti = 'Mở khoá thành công'
            }
          }
          await this.fetchData()
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
